// CRITICAL: Import dayjs configuration FIRST before any other imports
import "utils/dayjs";

import { LoadingOutlined } from "@ant-design/icons";
import { RouterProvider } from "@tanstack/react-router";
import { ConfigProvider as AntdConfigProvider } from "antd";
import mnMN from "antd/lib/locale/mn_MN";
import ForceChangePassword from "components/force_change_password";
import { StoreProvider, useStore } from "contexts";
import { FC } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { createRoot } from "react-dom/client";
import { router } from "routes/router";
import { registerForced2faInterceptor } from "utils/forced2fa";
import "./global.less";
import "./tailwind.css";

// Fallback trigger for the forced-2FA gate: any 403 carrying the setup marker
// flips the atom that ForceTwoFactor watches.
registerForced2faInterceptor();

const InnerApp: FC = () => {
  const [{ authorized }] = useStore();

  return (
    <>
      <RouterProvider
        router={router}
        context={{ authorized }}
      />
      <ForceChangePassword />
    </>
  );
};

const App = () => (
  <AntdConfigProvider
    popupMatchSelectWidth={false}
    spin={{
      indicator: <LoadingOutlined spin />,
    }}
    theme={{
      token: {
        colorPrimary: "#3C3F57",
        borderRadius: 8,
      },
      components: {
        Modal: {
          borderRadiusLG: 15,
        },
        Button: {
          borderRadiusLG: 12,
        },
      },
    }}
    locale={mnMN}
  >
    <StoreProvider>
      <DndProvider backend={HTML5Backend}>
        <InnerApp />
      </DndProvider>
    </StoreProvider>
  </AntdConfigProvider>
);

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);
root.render(<App />);
